export const FETCH_INVOICING_LOG_REQUEST = "FETCH_INVOICING_LOG_REQUEST";
export const FETCH_INVOICING_LOG_SUCCESS = "FETCH_INVOICING_LOG_SUCCESS";
export const FETCH_INVOICING_LOG_FAILURE = "FETCH_INVOICING_LOG_FAILURE";
export const FETCH_INVOICING_LOG_RESET = "FETCH_INVOICING_LOG_RESET";
export const fetchInvoicinglogRequest = (payload) => ({
    type: FETCH_INVOICING_LOG_REQUEST,
    payload,
});
export const fetchInvoicinglogSuccess = (payload) => ({
    type: FETCH_INVOICING_LOG_SUCCESS,
    payload,
});
export const fetchInvoicinglogFailure = (payload) => ({
    type: FETCH_INVOICING_LOG_FAILURE,
    payload,
});
export const fetchInvoicinglogReset = () => ({
    type: FETCH_INVOICING_LOG_RESET,
});
